import { render, staticRenderFns } from "./AddLeaves.vue?vue&type=template&id=8b6e77be"
import script from "./AddLeaves.vue?vue&type=script&lang=js"
export * from "./AddLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports